import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import { mapActions } from 'vuex';
import utils from '@/utils';
import table from '@/mixins/crud-table.js';
import { request } from '@/api/service';
import axios from 'axios'; // import QRcode from '@xkeshi/vue-qrcode'
// 在页面中引入文件
// import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  mixins: [table],
  components: {
    componentForm: function componentForm() {
      return import('./form');
    },
    componentForm2: function componentForm2() {
      return import('./form2');
    } // qrcode: VueQrcode,
    // qrcode: QRcode

  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var page = h("d2-container", {
      "attrs": {
        "spacious": true
      }
    }, [h("d2-search-panel", {
      "slot": "header",
      "model": {
        value: _this.search.panel.active,
        callback: function callback($$v) {
          _this.$set(_this.search.panel, "active", $$v);
        }
      }
    }, [h("d2-bar", {
      "slot": "title"
    }, [h("d2-bar-space"), this.p('query') ? h("d2-bar-cell", [this.vNodePaginationMini]) : h("d2-bar-cell", [this.vNodeSearchPanelAlertNoPermissionQuery]), h("d2-bar-space"), h("d2-bar-cell", [h("el-button-group", [this.p('query') ? this.vNodeButtonSearch : null, this.vNodeButtonTableColumnsFilterTrigger])]), this.p('add') ? h("d2-bar-cell", [this.vNodeButtonCreate]) : null]), this.p('query') ? this.vNodeSearchForm : null]), this.vNodeTable, h("d2-bar", {
      "slot": "footer"
    }, [h("d2-bar-cell", [this.vNodePaginationFull]), h("d2-bar-space")]), h("component-form", {
      "ref": "form",
      "on": {
        "success": this.research
      }
    }), h("component-form-2", {
      "ref": "form2",
      "on": {
        "success": this.research
      }
    }), this.vNodeTableColumnsFilter]);
    return page;
  },
  data: function data() {
    return {
      show_operation: false,
      api: {
        index: 'DEVICE_ALL',
        delete: 'DEVICE_DELETE',
        sync: 'DEVICE_SYNC'
      },
      permission: {
        query: '',
        add: '',
        edit: '',
        detail: 'device:detail',
        remove: '',
        device_connect_config: 'device-connect-config',
        device_recharge_config: 'device-recharge-config',
        device_recharge: '',
        box: '',
        sync_info: '',
        sync_bill: '',
        sync_apk: '',
        sync_config: '',
        device_bill: '',
        device_quick_login: 'device-quick-login'
      }
    };
  },
  computed: {
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      var h = this.$createElement;
      return [{
        prop: 'id',
        label: this.$t('id'),
        minWidth: '100px'
      }, {
        prop: 'device_number',
        label: this.$t('device_number'),
        minWidth: '100px'
      }, // { prop: 'market_id', label: this.$t('market_mobile'), minWidth: '120px', render: ({ row }) => <d2-dict name="table_market_id" value={ row.market_id } custom/> },
      {
        prop: 'help_phone',
        label: this.$t('help_phone'),
        minWidth: '100px'
      }, // { prop: 'charge_id', label: 'charge_id', minWidth: '100px', render: ({ row }) => <d2-dict name="table_charge_id" value={ row.charge_id } custom/> },
      {
        prop: 'device_name',
        label: this.$t('device_name'),
        minWidth: '100px'
      }, // { prop: 'ukey', label: 'ukey', minWidth: '100px' },
      {
        prop: 'device_address',
        label: this.$t('device_address'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return row.province + row.city + row.district + row.street;
        }
      }, {
        prop: 'device_line',
        label: this.$t('device_line'),
        minWidth: '100px',
        render: function render(_ref) {
          var row = _ref.row;
          return h("d2-dict", {
            "attrs": {
              "name": "device_line",
              "value": row.device_line
            }
          });
        }
      }, {
        prop: 'device_status',
        label: this.$t('device_status'),
        minWidth: '100px',
        render: function render(_ref2) {
          var row = _ref2.row;
          return h("d2-dict", {
            "attrs": {
              "name": "device_status",
              "value": row.device_status
            }
          });
        }
      }, {
        prop: 'device_type',
        label: this.$t('device_type'),
        minWidth: '100px',
        show: false
      }, // { prop: 'device_config_json', label: 'device_config_json', minWidth: '300px' , formatter: row => JSON.stringify(row.device_config_json)},
      {
        prop: 'start_servcie_time',
        label: this.$t('start_servcie_time'),
        minWidth: '100px',
        formatter: function formatter(row) {
          return utils.time.format1(row.start_servcie_time, 'YYYY/M/D HH:mm:ss');
        },
        show: false
      }, {
        prop: 'end_servcie_time',
        label: this.$t('end_servcie_time'),
        minWidth: '140px',
        formatter: function formatter(row) {
          return utils.time.format1(row.end_servcie_time, 'YYYY/M/D HH:mm:ss');
        }
      }, {
        prop: 'last_extend_service_long',
        label: this.$t('last_extend_service_long'),
        minWidth: '100px',
        show: false
      }, {
        prop: 'province',
        label: this.$t('province'),
        minWidth: '100px'
      }, {
        prop: 'city',
        label: this.$t('city'),
        minWidth: '100px'
      }, {
        prop: 'district',
        label: this.$t('district'),
        minWidth: '100px'
      }, {
        prop: 'street',
        label: this.$t('street'),
        width: '100px'
      }, {
        prop: 'longitude',
        label: this.$t('longitude'),
        width: '100px',
        show: false
      }, {
        prop: 'latitude',
        label: this.$t('latitude'),
        minWidth: '100px',
        show: false
      }, {
        prop: 'ctime',
        label: this.$t('ctime'),
        minWidth: '160px',
        formatter: function formatter(row) {
          return utils.time.format1(row.ctime, 'YYYY/M/D HH:mm:ss');
        }
      } // { prop: 'uptime', label: 'uptime', minWidth: '100px', formatter: row => utils.time.format1(row.uptime, 'YYYY/M/D HH:mm:ss') },
      // { prop: 'used_count', label: 'used_count', minWidth: '100px' },
      // { prop: 'used_month_count', label: 'used_month_count', minWidth: '100px' },
      // { prop: 'used_year_count', label: 'used_year_count', minWidth: '100px' },
      // { prop: 'used_sy', label: 'used_sy', minWidth: '100px' },
      // { prop: 'used_month_sy', label: 'used_month_sy', minWidth: '100px' },
      // { prop: 'used_year_sy', label: 'used_year_sy', minWidth: '100px' },
      // { prop: 'used_save_sy', label: 'used_save_sy', minWidth: '100px' },
      // { prop: 'used_month_save_sy', label: 'used_month_save_sy', minWidth: '100px' },
      // { prop: 'used_year_save_sy', label: 'used_year_save_sy', minWidth: '100px' },
      // { prop: 'used_get_sy', label: 'used_get_sy', minWidth: '100px' },
      // { prop: 'used_month_get_sy', label: 'used_month_get_sy', minWidth: '100px' },
      // { prop: 'used_year_get_sy', label: 'used_year_get_sy', minWidth: '100px' }
      ].map(function (setting) {
        setting.sortable = 'custom';
        return setting;
      });
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      var _this2 = this;

      return function (_ref3) {
        var row = _ref3.row;
        return [].concat(_toConsumableArray(_this2.p('edit', [{
          icon: 'el-icon-edit-outline',
          action: function action() {
            return _this2.edit(row.id);
          }
        }], [])), _toConsumableArray(_this2.p('detail', [{
          icon: 'el-icon-box',
          label: _this2.$t('detail'),
          action: function action() {
            return _this2.detail(row.id, 'form2');
          }
        }], [])), _toConsumableArray(_this2.p('box', [{
          icon: 'el-icon-collection',
          label: _this2.$t('box'),
          action: function action() {
            return _this2.goDictData(row.device_number);
          }
        }], [])), _toConsumableArray(_this2.show_operation ? _this2.p('device_connect_config', [{
          icon: 'el-icon-connection',
          label: _this2.$t('device_connect_config'),
          action: function action() {
            return _this2.goDeviceConnectConfigData(row.device_uid);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('device_recharge_config', [{
          icon: 'el-icon-connection',
          label: _this2.$t('device_recharge_config'),
          action: function action() {
            return _this2.goDeviceRechargeConfig(row.market_id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('device_recharge', [{
          icon: 'el-icon-wallet',
          label: _this2.$t('device_recharge'),
          action: function action() {
            return _this2.goDeviceRecharge(row.device_number);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_info', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync info'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_info'),
          action: function action() {
            return _this2.sync({
              'device_number': row.device_number,
              'optype': 'qr'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_bill', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync bill'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_bill'),
          action: function action() {
            return _this2.sync({
              'device_number': row.device_number,
              'optype': 'ad'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_apk', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync apk'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_apk'),
          action: function action() {
            return _this2.sync({
              'device_number': row.device_number,
              'optype': 'apk'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_config', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync config'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_config'),
          action: function action() {
            return _this2.sync({
              'device_number': row.device_number,
              'optype': 'confignotice'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('sync_charge', [{
          icon: 'el-icon-upload2',
          label: _this2.$t('sync charge'),
          type: 'danger',
          confirm: _this2.$t('confirm_sync_charge'),
          action: function action() {
            return _this2.sync({
              'device_number': row.device_number,
              'optype': 'charge'
            });
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('device_bill', [{
          icon: 'el-icon-help',
          label: _this2.$t('device_bill'),
          action: function action() {
            return _this2.goDeviceBill(row.device_number);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('device_quick_login', [{
          icon: 'el-icon-help',
          label: _this2.$t('device_quick_login'),
          action: function action() {
            return _this2.goDeviceQuickLogin(row.device_number);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? _this2.p('remove', [{
          icon: 'el-icon-delete',
          type: 'danger',
          confirm: _this2.$t('confirm_delete_info'),
          action: function action() {
            return _this2.delete(row.id);
          }
        }], []) : []), _toConsumableArray(_this2.show_operation ? [{
          icon: 'el-icon-collection',
          label: _this2.$t('hide'),
          action: function action() {
            return _this2.hide();
          }
        }] : [{
          icon: 'el-icon-collection',
          label: _this2.$t('show'),
          action: function action() {
            return _this2.show();
          }
        }]));
      };
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      var _this3 = this;

      var h = this.$createElement;
      return [{
        prop: 'device_number',
        label: this.$t('device_number'),
        default: '',
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this3.search.form.model.device_number,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "device_number", $$v);
              }
            }
          });
        }
      }, {
        prop: 'market_mobile',
        label: this.$t('market_mobile'),
        default: this.market_mobile ? this.market_mobile : utils.cookies.get('phone'),
        render: function render() {
          return h("el-input", {
            "style": "width:120px;",
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this3.search.form.model.market_mobile,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "market_mobile", $$v);
              }
            }
          });
        } // render: () => <d2-dict-select name="search_market_id" vModel={ this.search.form.model.market_id } style="width:120px;" custom clearable/>

      }, {
        prop: 'start_time',
        label: this.$t('start_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "start_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.start_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "start_time", $$v);
              }
            }
          });
        }
      }, {
        prop: 'end_time',
        label: this.$t('end_time'),
        default: '',
        render: function render() {
          return h("el-date-picker", {
            "attrs": {
              "value-format": "yyyy-MM-dd",
              "type": "date",
              "placeholder": "end_time"
            },
            "style": "width:130px;",
            "model": {
              value: _this3.search.form.model.end_time,
              callback: function callback($$v) {
                _this3.$set(_this3.search.form.model, "end_time", $$v);
              }
            }
          });
        }
      }];
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_mobile: function market_mobile() {
      return this.$route.query.market_mobile;
    }
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/page', ['closeBy'])), {}, {
    loadDict: function loadDict() {
      this.loadDictOne({
        name: 'search_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,market_mobile',
        path: 'list',
        label: 'market_mobile',
        value: 'id'
      });
      this.loadDictOne({
        name: 'table_charge_id',
        method: this.$api.CHARGE_CONFIGS_ALL,
        fields: 'id,charge_name',
        path: 'list',
        label: 'charge_name',
        value: 'id'
      });
    },
    goDictData: function goDictData(device_number) {
      this.closeBy(function (page) {
        return page.name === 'management-box';
      });
      this.$router.push({
        name: 'management-box',
        query: {
          device_number: device_number
        }
      });
    },
    goDeviceConnectConfigData: function goDeviceConnectConfigData(device_uid) {
      this.closeBy(function (page) {
        return page.name === 'management-device-connect-config';
      });
      this.$router.push({
        name: 'management-device-connect-config',
        query: {
          device_uid: device_uid
        }
      });
    },
    goDeviceRechargeConfig: function goDeviceRechargeConfig(market_id) {
      this.closeBy(function (page) {
        return page.name === 'management-device-recharge-config';
      });
      this.$router.push({
        name: 'management-device-recharge-config',
        query: {
          market_id: market_id
        }
      });
    },

    /* goDeviceRecharge (id) {
      this.closeBy(page => page.name === 'management-xufei')
      this.$router.push({
        name: 'management-xufei',
        query: {
          id: id,
          token: utils.cookies.get('token')
        }
      })
    }, */
    goDeviceRecharge: function goDeviceRecharge(device_number) {
      var mythis = this;
      request({
        method: 'post',
        url: '/api/device-recharge/create/recharge',
        data: {
          'device_number': device_number
        }
      }).then(function (res) {
        var app_id = res.app_id;
        var sign = res.sign;
        var market_id = res.market_id;
        var device_number = res.device_number;
        var order_no = res.order_no;
        var uqKey = res.uqKey;
        var dev_start_server_time = res.start_servcie_time;
        var dev_end_server_time = res.end_service_time;
        var src = res.src;
        axios.post(src, {
          'app_id': app_id,
          'order_no': order_no,
          'market_id': market_id,
          'device_number': device_number,
          'dev_start_server_time': dev_start_server_time,
          'dev_end_server_time': dev_end_server_time,
          'uqKey': uqKey,
          'sign': sign
        }).then(function (response) {
          console.log(response);

          if (response.data.code == 200) {
            var redis_token = response.data.data;
            console.log(redis_token);
            var index = src + '.html?redis_token=' + redis_token;
            utils.open(index);
          }
        }).catch(function (error) {
          console.log(error);

          if (error.message) {
            mythis.$message.error(error.message);
          } else {
            mythis.$message.error(error.data.msg);
          }
        });
      }); // this.closeBy(page => page.name === 'device-recharge')
      // this.$router.push({
      //   name: 'device-recharge',
      //   query: {
      //     device_number: device_number
      //   }
      // })
    },
    goDeviceBill: function goDeviceBill(device_number) {
      this.closeBy(function (page) {
        return page.name === 'management-device-bill';
      });
      this.$router.push({
        name: 'management-device-bill',
        query: {
          device_number: device_number
        }
      });
    },
    goDeviceQuickLogin: function goDeviceQuickLogin(device_number) {
      this.closeBy(function (page) {
        return page.name === 'management-device-quick-login';
      });
      this.$router.push({
        name: 'management-device-quick-login',
        query: {
          device_number: device_number
        }
      });
    },
    show: function show() {
      if (this.show_operation) {
        this.show_operation = false;
      } else {
        this.show_operation = true;
      }
    },
    hide: function hide() {
      if (this.show_operation) {
        this.show_operation = false;
      } else {
        this.show_operation = true;
      }
    }
  })
};